import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiOrdersService from "../../../core/api/api.ordersService";
import DataGridOrders from "./components/DataGridOrders";
import { FormProvider, useForm, Controller } from "react-hook-form";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { tools } from "../../../core/utils/tools";
import { useNavigate, useLocation } from "react-router-dom";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAgent from "../../../core/api/api.agent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";

const OrdersService = () => {
  const navigate = useNavigate();
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [basketItemCurrentStatus, setbasketItemCurrentStatus] = useState([]);
  const [basketCancelStatus, setbasketCancelStatus] = useState([]);
  const [amusementServiceList, setAmusementServiceList] = useState([]);
  const [group, setGroup] = useState([]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [amusementCityList, setAmusementCityList] = useState([]);
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);
  const [isExcel, setIsExcel] = useState(false);

  const [agents, setAgents] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        // const globalSearchFromUrl = searchParams.get("globalSearch")
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

        const data = await ApiOrdersService.getBasketPayment({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          createTimeOf: searchParams.get("createTimeOf"),
          createTimeTo: searchParams.get("createTimeTo"),
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          cancelStatus: _.toString(searchParams.get("cancelStatus")),
          orderStatus: _.toString(searchParams.get("orderStatus")),
          amusementServiceIds: _.toString(searchParams.get("amusementServiceIds")),
          orderPRiceOf: searchParams.get("orderPRiceOf"),
          orderPRiceTo: searchParams.get("orderPRiceTo"),
          amusementGroupIds: searchParams.get("amusementGroupIds"),
          globalSearch: searchParams.get("globalSearch"),
          cityIds: searchParams.get("cityIds"),
          amusementGroupIds: searchParams.get("amusementGroupIds"),
          amusementServiceReserveItemIds: searchParams.get("amusementServiceReserveItemIds"),
          amusementServiceReserveItemGroupIds: searchParams.get("amusementServiceReserveItemGroupIds"),
          agentId: searchParams.get("agentId")
        });

        setListData(data);
        setValue("totalCount", data.totalCount);

        const resultBasketItemCurrentStatus = await ApiOrdersService.GetEnumsName("BasketItemCurrentStatus");
        setbasketItemCurrentStatus(resultBasketItemCurrentStatus.data);

        const resultBasketCancelStatus = await ApiOrdersService.GetEnumsName("BasketCancelStatus");

        setbasketCancelStatus(resultBasketCancelStatus.data);
        const apiData = await ApiAmusementService.getAllServices();

        if (!_.isEmpty(apiData)) {
          setAmusementServiceList(apiData);
        } else {
          setAmusementServiceList([]);
        }

        const amusementItemIds = searchParams.get("amusementServiceIds")?.split(",") || [];
        const selectedServiceIds = apiData
          .filter((item) => amusementItemIds.includes(String(item.id)))
          ?.map((item) => ({ label: item.name, value: item.id }));

        const amusementGroupResult = await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 });
        setAmusementGroupList(amusementGroupResult.data);
        const cities = await ApiRegion.getAllCity();
        setAmusementCityList(cities);
        const agentsResponse = await ApiAgent.getAllAgentsName();
        setAgents(agentsResponse);

        const selectedItemsGroupIds = searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") || [];

        const selectedItemsItemIds = searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];
        inputChangeHandlerService(selectedServiceIds, true, selectedItemsGroupIds, selectedItemsItemIds);
        const formInputs = [
          { name: "orderPRiceOf", type: "text" },
          { name: "orderPRiceTo", type: "text" },
          { name: "createTimeOf", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          { name: "orderStatus", type: "multiSelect", isMulti: true, data: resultBasketItemCurrentStatus.data },
          { name: "cancelStatus", type: "multiSelect", isMulti: true, data: resultBasketCancelStatus.data },
          { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data: apiData },
          { name: "amusementGroupIds", type: "multiSelect", isMulti: true, data: amusementGroupResult.data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "cityIds", type: "multiSelect", isMulti: true, data: cities },
          {
            name: "agentId", type: "multiSelect", isMulti: false, data: agentsResponse?.data?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  const inputChangeHandlerService = async (
    event,
    firstRender = false,
    selectedItemsGroupIds = [],
    selectedItemsItemIds = []
  ) => {
    if (!firstRender) setValue("amusementServiceIds", event);

    if (event.length > 0) {
      const responses = await Promise.all(
        event.map(async ({ value }) => {
          const reserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(value);
          const reserveItemGroups = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(value);
          return [reserveItems, reserveItemGroups, value];
        })
      );

      let groupedReserveItemsOptions = [];
      let groupedReserveItemGroupOptions = [];
      let itemList = [];
      let groupList = [];

      responses.forEach(([reserveItems, reserveItemGroups, value]) => {
        const label = event.find((item) => item.value == value)?.label;

        const optionsItems = reserveItems.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        const optionsGroups = reserveItemGroups.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        groupedReserveItemsOptions.push({ label, options: optionsGroups }); // گروه آیتم‌ها
        groupedReserveItemGroupOptions.push({ label, options: optionsItems }); // آیتم‌ها

        if (firstRender) {
          const selectedGroupItems = reserveItemGroups
            .filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          const selectedItems = reserveItems
            .filter((item) => selectedItemsItemIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          itemList.push(...selectedGroupItems);
          groupList.push(...selectedItems);
        }
      });
      setGroupedReserveItemsOptions(groupedReserveItemsOptions);
      setGroup(groupedReserveItemGroupOptions);

      if (firstRender) {
        setValue("amusementServiceReserveItemGroupIds", itemList);
        setValue("amusementServiceReserveItemIds", groupList);
      }
    } else if (event.length === 0) {
      // وقتی هیچ تفریحی انتخاب نشده
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };
  const onSubmit = async (data) => {
    if (data.cityIds?.length > 0) data.cityIds = _.toString(data.cityIds?.map((item) => item.value));
    if (data.groupIdList?.length > 0) data.groupIdList = _.toString(data.groupIdList?.map((item) => item.value));
    if (data.amusementServiceReserveItemGroupIds?.length > 0)
      data.amusementServiceReserveItemGroupIds = _.toString(
        data.amusementServiceReserveItemGroupIds?.map((item) => item.value),
      );
    if (data.amusementServiceReserveItemIds?.length > 0)
      data.amusementServiceReserveItemIds = _.toString(data.amusementServiceReserveItemIds?.map((item) => item.value));
    if (!_.isEmpty(data.orderPRiceOf) && !validateNumberOrderPRiceOf(data.orderPRiceOf)) return;
    if (!_.isEmpty(data.orderPRiceTo) && !validateNumberOrderPRiceTo(data.orderPRiceTo)) return;
    if (data.createTimeOf !== null && typeof data.createTimeOf === "object") {
      data.createTimeOf = tools.DateFormat(data.createTimeOf);
    }
    if (data.createTimeTo !== null && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (data.useTimeOf !== null && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo !== null && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.cancelStatus?.length > 0) data.cancelStatus = data.cancelStatus?.map((item) => item.value);
    if (data.orderStatus?.length > 0) data.orderStatus = data.orderStatus?.map((item) => item.value);
    if (data.amusementServiceIds?.length > 0)
      data.amusementServiceIds = data.amusementServiceIds?.map((item) => item.value);
    if (data.amusementGroupIds?.length > 0) data.amusementGroupIds = data.amusementGroupIds?.map((item) => item.value);

    if (!_.isEmpty(data.orderPRiceOf)) data.orderPRiceOf = data.orderPRiceOf.replaceAll(",", "");
    if (!_.isEmpty(data.orderPRiceTo)) data.orderPRiceTo = data.orderPRiceTo.replaceAll(",", "");
    data.agentId = _.toString(data.agentId?.value);
    //if (data.agentId?.length > 0) data.agentId = _.toString(data.agentId?.map((item) => item.value));
    tools.setPageNumber(data, searchParams, setValue);
    if (isExcel) {
      await ApiOrdersService.getAllOrdersByExcel({
        pageSize: data.pageSize,
        pageNumber: data.pageNumber,
        globalSearch: data.globalSearch,
        createTimeOf: data.createTimeOf,
        createTimeTo: data.createTimeTo,
        useTimeOf: data.useTimeOf,
        useTimeTo: data.useTimeTo,
        cancelStatus: _.toString(data.cancelStatus),
        orderStatus: _.toString(data.orderStatus),
        amusementServiceIds: _.toString(data.amusementServiceIds),
        orderPRiceOf: data.orderPRiceOf,
        orderPRiceTo: data.orderPRiceTo,
        amusementGroupIds: _.toString(data.amusementGroupIds),
        cityIds: _.toString(data.cityIds),
        amusementServiceReserveItemGroupIds: _.toString(data.amusementServiceReserveItemGroupIds),
        amusementServiceReserveItemIds: _.toString(data.amusementServiceReserveItemIds),
        agentId: data.agentId
      }).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "Orders.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false);
    }
    const apiData = await ApiOrdersService.getBasketPayment({
      pageSize: data.pageSize,
      pageNumber: data.pageNumber,
      globalSearch: data.globalSearch,
      createTimeOf: data.createTimeOf,
      createTimeTo: data.createTimeTo,
      useTimeOf: data.useTimeOf,
      useTimeTo: data.useTimeTo,
      cancelStatus: _.toString(data.cancelStatus),
      orderStatus: _.toString(data.orderStatus),
      amusementServiceIds: _.toString(data.amusementServiceIds),
      orderPRiceOf: data.orderPRiceOf,
      orderPRiceTo: data.orderPRiceTo,
      amusementGroupIds: _.toString(data.amusementGroupIds),
      cityIds: _.toString(data.cityIds),
      amusementServiceReserveItemGroupIds: _.toString(data.amusementServiceReserveItemGroupIds),
      amusementServiceReserveItemIds: _.toString(data.amusementServiceReserveItemIds),
      agentId: data.agentId
    });

    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    const queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    // // اضافه کردن query string به URL و انتقال به آن URL
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    navigate(`/ordersList?${queryString}`);
  };

  function handleChangeMultiCityCancelStatus(value) {
    //setcancelStatus(value);
    setValue("cancelStatus", value);
  }
  function handleChangeMultiOrderStatus(value) {
    setValue("orderStatus", value);
  }

  const validateNumberOrderPRiceOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("orderPRiceOf", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("orderPRiceOf");
      return true;
    }
  };
  const validateNumberOrderPRiceTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("orderPRiceTo", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("orderPRiceTo");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت سفارشات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست سفارشات پرداخت شده</span>
          </h3>
          <div className="card-toolbar">
            <span className="badge badge-primary mx-1 font-weight-bold font-size-sm" style={{ backgroundColor: "#3699ff" }}>
              جدید/رهاسازی
            </span>
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ color: "#fff", backgroundColor: "rgb(182 206 232)" }}
            >
              درحال پیگیری
            </span>
            {/* <span className="btn btn-secondary mx-1 font-weight-bold font-size-sm" style={{backgroundColor:"#3699ff"}}>رهاسازی</span> */}
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ backgroundColor: "rgb(64 144 3 / 47%)" }}
            >
              انجام شد
            </span>
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ backgroundColor: "rgb(213 94 1 / 52%)" }}
            >
              انجام نشده
            </span>
            <span className="badge badge-danger mx-1 font-weight-bold font-size-sm" style={{ backgroundColor: "#f64e60" }}>
              درخواست کنسلی/رهاسازی کنسلی
            </span>
            <span
              className="badge badge-light-info mx-1 font-weight-bold font-size-sm"
              style={{ color: "#fff", backgroundColor: "#eee5ff" }}
            >
              درحال پیگیری کنسلی
            </span>
            {/* <span className="btn btn-light-secondary mx-1 font-weight-bold font-size-sm" style={{color:"#62e936",backgroundColor:"#f64e60"}}>رهاسازی کنسلی</span> */}
            <span
              className="badge badge-light-success mx-1 font-weight-bold font-size-sm"
              style={{ color: "#fff", backgroundColor: "hwb(13deg 3% 40% / 40%)" }}
            >
              کنسل شد
            </span>
            <span
              className="badge badge-light-warning mx-1 font-weight-bold font-size-sm"
              style={{ color: "#fff", backgroundColor: "rgb(213 149 14 / 40%)" }}
            >
              رددرخواست کنسلی
            </span>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="border-top pt-3">
                  {/* search box */}
                  <Accordion>
                    <Card>
                      <Accordion.Header as={Card.Header} variant="link">
                        <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Card.Body>
                          <Row>
                            <Col xs="12" sm="6" xl="3" className=" px-2 mt-5">
                              <Controller
                                name="orderPRiceOf"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    className="w-100"
                                    customInput={TextField}
                                    label="مبلغ سفارش از"
                                    size="small"
                                    type="search"
                                    value={value || ""}
                                    variant="outlined"
                                    thousandSeparator=","
                                    //decimalScale="0"
                                    //prefix=" تومان "
                                    error={!!errors.orderPRiceOf}
                                    onValueChange={(values) => {
                                      onChange(values.value || "");
                                      validateNumberOrderPRiceOf(values.value);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                  //  <TextField
                                  //         label='شماره موبایل'
                                  //         margin="normal"
                                  //         variant="outlined"
                                  //         size='small'
                                  //         value={value || ""}
                                  //         onChange={onChange}
                                  //     />
                                )}
                              />
                              {errors.orderPRiceOf && (
                                <div className="text-small-1 mt-2 text-danger"> {errors.orderPRiceOf.message}</div>
                              )}
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2 mt-5">
                              <Controller
                                name="orderPRiceTo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    className="w-100"
                                    customInput={TextField}
                                    label="مبلغ سفارش تا"
                                    size="small"
                                    value={value || ""}
                                    variant="outlined"
                                    thousandSeparator=","
                                    //decimalScale="0"
                                    //prefix=" تومان "
                                    error={!!errors.orderPRiceTo}
                                    onValueChange={(values) => {
                                      onChange(values.value || "");
                                      validateNumberOrderPRiceTo(values.value);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                    type="search"
                                  />
                                  //  <TextField
                                  //         label='شماره موبایل'
                                  //         margin="normal"
                                  //         variant="outlined"
                                  //         size='small'
                                  //         value={value || ""}
                                  //         onChange={onChange}
                                  //     />
                                )}
                              />
                              {errors.orderPRiceTo && (
                                <div className="text-small-1 mt-2 text-danger"> {errors.orderPRiceTo.message}</div>
                              )}
                            </Col>

                            <Col xs="12" sm="6" xl="3" className="tb-responsive px-2  mt-5">
                              <Controller
                                name="createTimeOf"
                                control={control}
                                render={({ field: { onChange, value } }) => {
                                  return (
                                    <ShamsiDatePicker
                                      value={value}
                                      onChange={(date) => {
                                        var createTimeTo = getValues("createTimeTo");
                                        onChange(date);
                                        if (
                                          !createTimeTo ||
                                          (date?.toDate && date?.toDate()?.getTime() > new Date(createTimeTo).getTime())
                                        ) {
                                          // Set the value of createTimeTo to the same as createTimeTo
                                          setValue("createTimeTo", date);
                                        }
                                      }}
                                      placeholder="زمان ایجاد از"
                                    />
                                  );
                                }}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2 mt-5">
                              <Controller
                                name="createTimeTo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ایجاد تا" />
                                )}
                              />
                            </Col>

                            <Col xs="12" sm="6" xl="3" className=" px-2">
                              <Controller
                                name="useTimeOf"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker
                                    className="mt-5"
                                    value={value}
                                    //onChange={onChange}
                                    onChange={(date) => {
                                      var useTimeTo = getValues("useTimeTo");
                                      onChange(date);
                                      if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                        // Set the value of useTimeTo to the same as useTimeOf
                                        setValue("useTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان انجام تفریح از"
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2">
                              <Controller
                                name="useTimeTo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker
                                    className="mt-5"
                                    value={value}
                                    onChange={onChange}
                                    placeholder="زمان انجام تفریح تا"
                                  />
                                )}
                              />
                            </Col>

                            <Col xs="12" sm="6" xl="3" className=" px-2 mt-5">
                              <Controller
                                name="orderStatus"
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-0"
                                    placeholder="وضعیت سفارش"
                                    options={[
                                      {
                                        value: "0,2",
                                        label: "0-جدید و 2-رهاسازی",
                                      },
                                      ...basketItemCurrentStatus
                                        .filter((item) => item.id != 0 && item.id != 2)
                                        .map((item) => ({
                                          value: item.id,
                                          label: item.id + "-" + item.title,
                                        })),
                                    ]}
                                    field={field}
                                    onChange={handleChangeMultiOrderStatus}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2 mt-5 ">
                              <Controller
                                name="cancelStatus"
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-0"
                                    placeholder="وضعیت کنسل"
                                    options={basketCancelStatus?.map((item) => ({
                                      value: item.id,
                                      label: item.id + "-" + item.title,
                                    }))}
                                    field={field}
                                    onChange={handleChangeMultiCityCancelStatus}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="mt-5  px-2 ">
                              <Controller
                                name="cityIds"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-0"
                                    placeholder=" شهر"
                                    options={amusementCityList?.map((item) => ({
                                      value: item.id,
                                      label: item.id + "-" + item.name,
                                    }))}
                                    isMulti
                                    field={field}
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2">
                              <Controller
                                name="amusementGroupIds"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className=" mt-5"
                                    placeholder="دسته تفریح"
                                    options={amusementGroupList?.map((item) => ({ value: item.id, label: item.title }))}
                                    isMulti
                                    field={field}
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className=" px-2 ">
                              <Controller
                                name="amusementServiceIds"
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-5"
                                    placeholder=" تفریح"
                                    options={amusementServiceList?.map((item) => ({
                                      value: item.id,
                                      label: item.id + "-" + item.name,
                                    }))}
                                    field={field}
                                    onChange={(e) => inputChangeHandlerService(e)}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="  px-2 mb-4">
                              <Controller
                                name="amusementServiceReserveItemGroupIds"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="w-20 mt-5"
                                    placeholder="گروه آیتم"
                                    options={groupedReserveItemsOptions || []}
                                    field={field}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="  px-2">
                              <Controller
                                name="amusementServiceReserveItemIds"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="w-20 mt-0"
                                    placeholder="آیتم"
                                    options={group || []}
                                    field={field}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="  px-2">
                              <Controller
                                name="agentId"
                                control={control}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="w-20 mt-0"
                                    placeholder="نماینده فروش "
                                    options={agents?.map((item) => ({ value: item.id, label: item.companyName }))}
                                    field={field}
                                  />
                                )}
                              />
                            </Col>
                          </Row>
                          <Row className="pt-3">
                            <Col xs="auto" className=" px-2 px-3 mt-3">
                              <Button variant="success" type="submit" disabled={isSubmitting}>
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <SearchIcon />
                                جستجو
                              </Button>
                            </Col>
                            <Col xs="auto" className=" px-2 mt-3">
                              <Button
                                variant="light-danger"
                                type="submit"
                                disabled={isSubmitting}
                                onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                              >
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <i className="fas fa-refresh text-small"></i>
                                حذف جستجو{" "}
                              </Button>
                            </Col>
                            <Col xs="auto" className=" px-2 mt-3">
                              <Button
                                className="ml-2"
                                variant="info"
                                type="submit"
                                disabled={isSubmitting}
                                onClick={() => {
                                  setIsExcel(true);
                                }}
                              >
                                {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                                <InsertDriveFile /> فایل اکسل
                            </Button>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Accordion.Body>
                    </Card>
                  </Accordion>
                  <InputGroup className="my-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />

                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>
                {/* table */}
                <Col xs="12" className=" px-0">
                  <DataGridOrders data={listData} />
                </Col>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersService;
